
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onlyfans-protection",
      function () {
        return require("private-next-pages/onlyfans-protection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/onlyfans-protection"])
      });
    }
  